const getRootExperimentationGroupSelector = (state) => state.workspace_data.workspace;
const getWSSPlitMigrationDataSelector = (state) => state.workspace_data.migration;
export {
  getRootExperimentationGroupSelector,
  getWSSPlitMigrationDataSelector
};
//# sourceMappingURL=GetWorkspace.selectors.js.map
